import React, { useState, useEffect } from 'react';
import { apiService } from './services/api'; 
import './style/PageStyle/ContractTemplates.css'; 

const ContractTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 1. Fetch Templates from Backend
  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true);
        const data = await apiService.getDocuSignTemplates(); 
        setTemplates(data || []);
      } catch (err) {
        console.error("Failed to load templates", err);
        setError("Could not load templates. Check your DocuSign settings.");
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  // 2. Handle Sending Contract
  const handleSendContract = async (templateId, templateName) => {
    const signerEmail = prompt(`Enter email to send "${templateName}" to:`);
    if (!signerEmail) return;

    const signerName = prompt("Enter the signer's name:");
    if (!signerName) return;

    try {
      // Optional: Add a loading toast here instead of alert
      alert("Sending... please wait.");
      
      const result = await apiService.sendDocuSignEnvelope({
        templateId,
        signerEmail,
        signerName
      });

      if (result && result.success) {
        alert(`Success! Envelope ID: ${result.envelopeId}`);
      } else {
        alert("Failed to send. Check console.");
      }
    } catch (err) {
      console.error(err);
      alert("Error sending contract: " + err.message);
    }
  };

  return (
    <div className="page-container">
      <h2>DocuSign Contract Templates</h2>
      <p>Select a template below to send to a user.</p>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <p className="loading-message">Loading templates from DocuSign...</p>
      ) : templates.length === 0 ? (
        <p className="empty-message">No templates found. Please create templates in your DocuSign account.</p>
      ) : (
        <table className="templates-table">
          <thead>
            <tr>
              <th>Template Name</th>
              <th>Template ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((t) => (
              <tr key={t.templateId}>
                <td className="template-name">{t.name}</td>
                <td><span className="template-id">{t.templateId}</span></td>
                <td>
                  <button 
                    className="send-btn"
                    onClick={() => handleSendContract(t.templateId, t.name)}
                  >
                    Send to User
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ContractTemplates;
